let ApexCharts = require('apexcharts')
import {formatBytes} from "../util/format-bytes";

$(function () {
    $('[data-chart-load]').each(function () {
        let self = $(this);
        let url = self.data('chart-load');
        let noData = self.data('chart-no-data');
        let chartOptions = {
            chart: {
                group: "charts",
                height: self.data('chart-height') ?? 350,
                type: 'line',
            },
            dataLabels: {
                enabled: false
            },
            series: [],
            title: {
                text: self.data('chart-title'),
            },
            noData: {
                text: self.data('chart-loading')
            },
            xaxis: {
                type: "datetime",
            },
            yaxis: {
                labels: {}
            },
            tooltip: {
                shared: true,
                x: {
                    format: self.data('chart-time-format') ? self.data('chart-time-format') : "dd. MMM yy"
                }
            }
        };
        var yaxisType = self.data('chart-y-axis')
        if (yaxisType === 'bytes') {
            chartOptions.yaxis.labels.formatter = function (val, index) {
                return formatBytes(val);
            }
        }
        var chart = new ApexCharts(self[0], chartOptions);
        chart.render();
        $.getJSON(url, function (res) {
            if (!Array.isArray(res) || res.length === 0) {
                chart.updateOptions({
                    noData: {
                        text: noData
                    }
                }, true, true, true)
            } else {
                chart.updateSeries(res)
            }
        }).fail(function () {

        });
    });
})
